import '@uppy/core/dist/style.css'
import '@uppy/dashboard/dist/style.css'
import { Dashboard } from '@uppy/react'
import { useUppy, useUppyPluginContext } from '../FileUploaderProvider/react'
import React from 'react'

export default function FileUploaderDashboard(props) {
  let uppy = useUppy(props)
  let [plugins] = useUppyPluginContext(props)

  return (
    <Dashboard
      proudlyDisplayPoweredByUppy={false}
      plugins={plugins}
      // added key to trigger rerender so that Uppy picks up the plugins
      key={JSON.stringify(plugins)}
      uppy={uppy}
      note={props.note}
      width={props.width}
      height={props.height}
      hideUploadButton={props.hideUploadButton}
      style={{
        marginTop: props.marginTop,
      }}
      // singleFileFullScreen={props.singleFileFullScreen}
    />
  )
}
